<div class="left-modal">
  @if (loading) {
    <div class="loader"></div>
  }
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <div class="modal-info-container">
        <h1>{{'Service' | translate}}</h1>
        <div class="boxContainer">
          @if (serviceFiles.length) {
            <div class="L-12 M-12 S-12 columns noMargin">
              <div class="box" style="padding-bottom: 0;">
                <app-service-files-view
                  [service]="selectedService"
                  [files]="serviceFiles"
                  [fileNameProperty]="'file_name'"
                  [type]="'service'"
                  (notify)="update()">
                </app-service-files-view>
              </div>
            </div>
          }
          @if (showProject) {
            <div class="L-12 M-12 S-12 columns noMargin">
              <div class="box">
                <label>{{'Project' | translate}}</label>
                {{selectedService.title}}
              </div>
            </div>
          }
          @if (!isShooting) {
            <div class="L-4 M-4 S-4 columns noMargin">
              <div class="box">
                <label>{{'Date' | translate}}</label>
                {{selectedService.date | date:'MMM-dd-y'}}
              </div>
            </div>
          }
          @if (!isShooting) {
            <div class="L-4 M-4 S-4 columns noMargin">
              <div class="box">
                <label>{{'Unit' | translate}}</label>
                {{selectedService.unit_number ? selectedService.unit_number : '--'}}
              </div>
            </div>
          }
          <div class="columns noMargin" [ngClass]="{'L-6 M-6 S-6': isShooting, 'L-4 M-4 S-4': !isShooting}">
            <div class="box">
              <label>{{'Status' | translate}}</label>
              {{_gS.backTranslate(selectedService, 'se_st_name','--')}}
            </div>
          </div>
          <div class="columns noMargin" [ngClass]="{'L-6 M-6 S-6': isShooting, 'L-4 M-4 S-4': !isShooting}">
            <div class="box">
              <label>{{'Category' | translate}}</label>
              {{_gS.backTranslate(selectedService, 'category_name','--')}}
            </div>
          </div>
          <div class="columns noMargin" [ngClass]="{'L-8 M-8 S-8': isShooting, 'L-4 M-4 S-4': !isShooting}">
            <div class="box">
              <label>{{'Vendor' | translate}}</label>
              {{selectedService.vendor ? selectedService.vendor : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Document' | translate}}</label>
              {{selectedService.nit ? selectedService.nit : '--'}}
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns noMargin">
            <div class="box">
              <label>{{'Description' | translate}}</label>
              {{selectedService.description ? selectedService.description : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'On location' | translate}}</label>
              {{selectedService.call_time ? (_gS.getStaticDateHour(selectedService.call_time) | date: 'h:mm a') : '--:-- --'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Arrive' | translate}}</label>
              {{selectedService.arrive ? (_gS.getStaticDateHour(selectedService.arrive) | date: 'h:mm a') : '--:-- --'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Wrap' | translate}}</label>
              {{selectedService.wrap ? (_gS.getStaticDateHour(selectedService.wrap) | date: 'h:mm a') : '--:-- --'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Quantity' | translate}}</label>
              {{selectedService.quantity ? selectedService.quantity : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Unit cost' | translate}}</label>
              {{selectedService.cost_unit ? (selectedService.cost_unit | currency: '$') : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Lunch' | translate}}</label>
              {{selectedService.lunch ? (selectedService.lunch | currency: '$') : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'H Extras' | translate}}</label>
              {{selectedService.extra ? (selectedService.extra | currency: '$') : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Periphery' | translate}}</label>
              {{selectedService.periphery ? (selectedService.periphery | currency: '$') : '--'}}
            </div>
          </div>
          <div class="L-4 M-4 S-4 columns noMargin">
            <div class="box">
              <label>{{'Total' | translate}}</label>
              {{selectedService.total_cost ? (selectedService.total_cost | currency: '$'): '--'}}
            </div>
          </div>
          <div class="columns noMargin" [ngClass]="{'L-12 M-12 S-12': isShooting, 'L-6 M-6 S-6 ': !isShooting}">
            <div class="box">
              <label>{{'Purchase order' | translate}}</label>
              {{selectedService.po ? selectedService.po : '--'}}
            </div>
          </div>
          @if (!isShooting) {
            <div class="L-6 M-6 S-6 columns noMargin">
              <div class="box">
                <label>{{'Invoice' | translate}}</label>
                {{selectedService.invoice ? selectedService.invoice : '--'}}
              </div>
            </div>
          }
          <div class="L-12 M-12 S-12 columns noMargin">
            <div class="box">
              <label>{{'Observations' | translate}}</label>
              {{selectedService.observation ? selectedService.observation : '--'}}
            </div>
          </div>
        </div>
        @if (!isShooting && !isUpdatingService) {
          <div class="button-status-wrapper">
            @if (service.service_status_id == SERVICE_STATUS.Pending || service.service_status_id == SERVICE_STATUS.OnProccess) {
              <div class="L-12 M-12 S-12 columns TextCentered">
                <input (click)="changeStatusService(1)"  name="sumbit" type="submit" value="{{'Mark as new' | translate}}" >
              </div>
            }
            @if (service.service_status_id == SERVICE_STATUS.New || service.service_status_id == SERVICE_STATUS.Modified || service.service_status_id == SERVICE_STATUS.OnProccess) {
              <div class="L-12 M-12 S-12 columns TextCentered"
                >
                <input (click)="changeStatusService(2)" name="sumbit" type="submit" value="{{'Mark as pending' | translate}}" >
              </div>
            }
            @if (service.service_status_id == SERVICE_STATUS.New || service.service_status_id == SERVICE_STATUS.Modified) {
              <div class="L-12 M-12 S-12 columns TextCentered">
                <input (click)="changeStatusService(4)"  name="sumbit" type="submit" value="{{'On process' | translate}}" >
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>